module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"addUserDialog_Header":"Crea Account Collegato","createuser_Success":"Utente creato!","createuser_Error":"Utente non creato!","Name":"Nome","Surname":"Cognome","FullName":"Nome Cognome","formCreateSubAccount":{"OwnerAccountId":"Account Principale","Name":"Nome","Surname":"Cognome","UserName":"Nome Utente","Email":"E-mail","Password":"Password"}}}')
  delete Component.options._Ctor
}
